import styled from 'styled-components' ;

export const Container = styled.div`
  position: fixed;
  left: 0;
  bottom: 0;
  width:100% ;
  background-color:#f4f4f4 ;
  text-align:center ;
  padding: 6px;
  font-size:small ;
  color: #070707 
`;
export const Spacer = styled.div`
  width:100%;
  height: 50px;
`;